export const MENU_SOUNDS = {
  menu_button_click: 'menu_button_click',
  faction_select: 'faction_select',
  side_menu_click: 'side_menu_click',
  timer: 'timer',
  chest_open: 'chest_open',
  chest_eternal: 'chest_eternal',
  card_open: 'card_open',
  game_start: 'game_start',
  select_unit_enemy: 'select_unit_enemy',
  special_building_guild: 'special_building_guild',
  // Тот же звук, что звучит при разведке рудника гномами (см. SoundManager.
  // playDwarvesMineExploration) — используется модалками кристаллов
  dwarves_mine_exploration_1: 'dwarves_mine_exploration_1',
  modal_round_end: 'modal_round_end',
};

export const FACTION_SOUNDS = {
  faction_pick_aquars_1: 'faction_pick_aquars_1',
  faction_pick_aquars_2: 'faction_pick_aquars_2',
  faction_pick_demons: 'faction_pick_demons',
  faction_pick_dragons: 'faction_pick_dragons',
  faction_pick_dwarves: 'faction_pick_dwarves',
  faction_pick_elves: 'faction_pick_elves',
  faction_pick_giants: 'faction_pick_giants',
  faction_pick_giants_2: 'faction_pick_giants_2',
  faction_pick_giants_3: 'faction_pick_giants_3',
  faction_pick_goblins: 'faction_pick_goblins',
  faction_pick_insectoids: 'faction_pick_insectoids',
  faction_pick_spirits: 'faction_pick_spirits',
  faction_pick_undead: 'faction_pick_undead',
  faction_pick_beastmen: 'faction_pick_beastmen',
  faction_pick_celestials: 'faction_pick_celestials',
  faction_pick_dark_elves: 'faction_pick_dark_elves',
  faction_pick_succubes: 'faction_pick_succubes',
  faction_pick_succubes_1: 'faction_pick_succubes_1',
  faction_pick_ents_1: 'faction_pick_ents_1',
  faction_pick_ents_2: 'faction_pick_ents_2',
  faction_pick_ents_3: 'faction_pick_ents_3',
  faction_pick_fenix: 'faction_pick_fenix',
  faction_pick_orks: 'faction_pick_orks',
  faction_pick_mushroom_people: 'faction_pick_mushroom_people',
  faction_pick_humans: 'faction_pick_humans',
  faction_pick_ratmen: 'faction_pick_ratmen',
  faction_pick_gremlins_1: 'faction_pick_gremlins_1',
  faction_pick_gremlins_2: 'faction_pick_gremlins_2',
  faction_pick_technodwarves: 'faction_pick_technodwarves',
  faction_pick_elementals_1: 'faction_pick_elementals_1',
  faction_pick_elementals_2: 'faction_pick_elementals_2',
  faction_pick_elementals_3: 'faction_pick_elementals_3',
  faction_pick_wizards_1: 'faction_pick_wizards_1',
  faction_pick_wizards_2: 'faction_pick_wizards_2',
  faction_pick_dopplers: 'faction_pick_dopplers',

  faction_pick_ventory: 'faction_pick_ventory',
  special_building_guild: 'special_building_guild',

  leprechauns_laugh: 'leprechauns_laugh',
  leprechauns_coins: 'leprechauns_coins',

  coins_many_1: 'coins_many_1',
  coins_many_2: 'coins_many_2',
  coins_many_3: 'coins_many_3',
  special_building_temple: 'special_building_temple',
  factions_pick_enlightened: 'factions_pick_enlightened',
};
